import userManagement from '../apis/userManagement.api';
import { AxiosResponse } from 'axios';
import { UserSettings } from '../types';

export const getUserSettings = (): Promise<AxiosResponse<UserSettings>> => {
	return userManagement.get('user/v1/user-settings');
};

export const updateUserSettings = (
	settings: Partial<UserSettings>,
): Promise<AxiosResponse<UserSettings>> => {
	return userManagement.post('user/v1/user-settings', settings);
};
